// extracted by mini-css-extract-plugin
module.exports = {"Rating":"RateTransactionModal_Rating__38Wcb"};